import { createContext } from "react";
import React from 'react';
import useModal from "../hooks/useModal";
import useModalReport from "../hooks/useModalReport";

export const ModalContext = createContext({})

export function ModalProvider({ children }) {

    const modal = useModal()
    const modalReport = useModalReport()

    return (
        <ModalContext.Provider value={{ ...modal, ...modalReport }}>
            {children}
        </ModalContext.Provider>
    )
}